import { SocialLinks } from 'social-links';

import IconFacebook from '../shared/assets/social-icons/facebook';
import IconInstagram from '../shared/assets/social-icons/instagram';
import IconTiktok from '../shared/assets/social-icons/tiktok';
import IconTwitter from '../shared/assets/social-icons/twitter';
import IconYoutube from '../shared/assets/social-icons/youtube';

const socialLinks = new SocialLinks();

export const sanitiseSocialLinks = (code: string, handle: string) => {
  const { profileName } = getSocialPlatformInfo(code);
  return socialLinks.sanitize(profileName!, handle);
};

export const isSocialHandleValid = (code: string, handle: string) => {
  const { profileName } = getSocialPlatformInfo(code);
  return socialLinks.isValid(profileName!, handle);
};

export const getSocialPlatformInfo = (code: string) => {
  const profileName = {
    FB: 'facebook',
    TW: 'twitter',
    IG: 'instagram',
    YT: 'youtube',
    TT: 'tiktok',
  }[code];
  const IconInner = {
    FB: IconFacebook,
    TW: IconTwitter,
    IG: IconInstagram,
    YT: IconYoutube,
    TT: IconTiktok,
  }[code];
  const Icon = (
    <div className="w-9 h-9 flex items-center justify-center text-pale-highlight bg-secondary rounded-lg p-1">
      {IconInner && <IconInner />}
    </div>
  );
  const name = {
    FB: 'Facebook',
    TW: 'X',
    IG: 'Instagram',
    YT: 'YouTube',
    TT: 'TikTok',
  }[code];
  return { code, name, Icon, profileName };
};
